import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "register-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "input_container" }
const _hoisted_5 = { class: "input_container" }
const _hoisted_6 = {
  key: 0,
  class: "password-error"
}
const _hoisted_7 = { class: "input_container" }
const _hoisted_8 = {
  key: 0,
  class: "password-error"
}
const _hoisted_9 = { class: "form-field" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import SimpleLayout from '@/layouts/simple/SimpleLayout.vue';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import logoImage from '@/assets/images/BeePallet_Logo_Black.png';
import {showErrorAlert, showExceptionAlert, showInfoAlertWithConfirmation} from "@/helpers/SweetAlertHelper";
// import { CustomerProfileService } from "@/services/backend/CustomerService";
// import { UserService } from "@/services/backend/UserService";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import * as Session from "supertokens-web-js/recipe/session";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import CheckboxComponent from '@/components/core/fields/Checkbox/CheckboxComponent.vue';
import LoadingComponent from '@/components/common/LoadingComponent/LoadingComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterPage',
  setup(__props) {

const email = ref('');
const password = ref('');
const repeatPassword = ref('');
const router = useRouter();
const showMatchError = ref<boolean>(false);
const showPassError = ref<boolean>(false)
const acceptance = ref<boolean>(false);
const showAcceptanceError = ref<boolean>(false);
const isLoading = ref<boolean>(false);

const handleSubmit = async () => {
  showMatchError.value = false;
  showPassError.value = false;
  if (password.value !== repeatPassword.value) {
    showMatchError.value = true;
    return;
  }

  console.log(acceptance.value)
	if(!acceptance.value){
		showAcceptanceError.value = true;
    return;
	}

  try {
    isLoading.value = true; 
    const response = await EmailPassword.signUp({
      formFields: [
        { id: "email", value: email.value },
        { id: "password", value: password.value },
      ],
      shouldTryLinkingWithSessionUser: false
    });

    if (response.status === "OK") {
      await EmailVerification.sendVerificationEmail();
      showInfoAlertWithConfirmation("Confirma tu email", 
                                "<p>Por favor, revisa tu bandeja de entrada para confirmar tu email.</p></p>Si no ves el correo, revisa tu bandeja de correo no deseado.</p>",
                                goToLogin);
      await Session.signOut();
      LocalStorageService.clearAll();
      // const userId = await UserService.getUserId();
      // await CustomerProfileService.getCustomerProfile(userId);
      // router.push({ name: "home" });
    } else if(response.status==='FIELD_ERROR'){
      showPassError.value = true;
    } else{
      showErrorAlert("Error al registrarse");
    }
  } catch (error) {
    showExceptionAlert(error);
  }
  finally{
    isLoading.value = false;
  }
};

const goToLogin = ()=>{
  router.push({ name: 'login' })
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(SimpleLayout, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "home" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(logoImage),
                class: "beepallet-logo",
                alt: "Logo de BeePallet"
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            class: "register-form",
            onSubmit: _withModifiers(handleSubmit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                class: "input_label",
                for: "email"
              }, "E-mail", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input-field is-placeholder",
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                class: "input_label",
                for: "password"
              }, "Contraseña", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                class: "input-field is-placeholder",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, password.value]
              ]),
              (showPassError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Debe contener al menos 8 caracteres incluido un número."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                class: "input_label",
                for: "repeatPassword"
              }, "Repetir Contraseña", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "repeatPassword",
                class: "input-field is-placeholder",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatPassword).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, repeatPassword.value]
              ]),
              (showMatchError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Las contraseñas no coinciden."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(CheckboxComponent, {
                modelValue: acceptance.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((acceptance).value = $event)),
                "has-error": !acceptance.value && showAcceptanceError.value
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(['custom-checkbox-label', {error:showAcceptanceError.value&&!acceptance.value}])
                  }, [
                    _cache[8] || (_cache[8] = _createTextVNode("Declaro haber leído, entendido y aceptado los ")),
                    _createVNode(_component_RouterLink, {
                      class: "btn-underline-black",
                      target: "_blank",
                      to: { name: 'terms_conditions' }
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("Términos y Condiciones del servicio")
                      ])),
                      _: 1
                    }),
                    _cache[9] || (_cache[9] = _createTextVNode("."))
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue", "has-error"])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("button", {
              type: "submit",
              class: "btn-primary-m btn-primary-green"
            }, "Registrarse", -1)),
            _createVNode(_component_router_link, {
              to: "/auth/login",
              class: "btn-secondary-black"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" ¿Ya tienes una cuenta? "),
                _createElementVNode("span", { class: "highlight" }, "Inicia sesión", -1)
              ])),
              _: 1
            })
          ], 32)
        ]),
        _createVNode(LoadingComponent, {
          "is-loading": isLoading.value,
          overlay: true
        }, null, 8, ["is-loading"])
      ])
    ]),
    _: 1
  }))
}
}

})